<template>
  <div class="notice-page">
    <div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back">
      {{ $t('pageTitle.noticeDetail') }} </div>
    <div class="notice-detail">
      <div class="title">{{noticeData.Title}}</div>
      <div class="time">{{noticeData.CreatedAt}}</div>
      <div class="content" v-html="noticeData.Content"></div>
    </div>
  </div>
</template>
<script>
import { getNoticeList } from '@/api/index'
export default {
  components: {
  },
  data() {
    return {
      title: '',
      noticeData: {},
      backUrl: require('../../assets/imgs/icon-back.png')
    }
  },
  mounted() {
    let data = sessionStorage.getItem('noticeDetail')
    if (data) {
      this.noticeData = JSON.parse(data)
      this.title = this.noticeData.Title
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    readAll() {

    }
  }
}
</script>